// The frozen "New messages" divider follows a read made on ANOTHER device (#514).
// A live read arrives as `read_broadcast` (the relay never echoes a socket's own
// read back to it). A read made while this device was offline only shows up in the
// reconnect seed, so the seed is compared with the cursor this device already
// knew: the server can only be ahead of it because another device read further.
// Pure so the rule is testable without app.svelte.ts (Svelte runes).

/** The server cursor to advance the open divider to, or undefined when nothing new. */
export function serverReadAhead(
  known: number | null,
  server: number | undefined,
): number | undefined {
  if (server === undefined) return undefined;
  return server > (known ?? 0) ? server : undefined;
}
